export default __webpack_public_path__ + "static/media/background.b292e070.jpg";